import { gql, type TypedDocumentNode } from '@apollo/client';

// Backend PR #12391 introduces this mutation; it is not in the staging schema
// used by gql.tada yet. Keep the document and variables typed meanwhile.
export const CREATE_OUTLOOK_DRAFT_FROM_PREVIEW: TypedDocumentNode<
  { createOutlookDraftFromPreview: { parts: unknown } | null },
  { input: { chatUuid: string; messageUuid: string; toolCallId: string } }
> = gql`
  mutation CreateOutlookDraftFromPreview($input: OutlookDraftFromPreviewInput!) {
    createOutlookDraftFromPreview(input: $input) {
      parts
    }
  }
`;
